import React, {Component} from "react";
import {
    Panel,
    Tabs,
    Tab,
    Badge
}                           from 'react-bootstrap';

export default class ServerProcessMonitoring extends Component {
    constructor (props) {
        super(props);

        this.state = {
            cloudFunctionLogs: []
        };

        this.onCloudFunctionStart = this.onCloudFunctionStart.bind(this);
        this.onCloudFunctionEnd = this.onCloudFunctionEnd.bind(this);
    }

    onCloudFunctionStart (data) {
        let {
            cloudFunctionLogs
        } = this.state;

        let requestIds = cloudFunctionLogs.map((item) => item.requestId);

        if (requestIds.indexOf(data.requestId) === -1) {
            let clone = cloudFunctionLogs.map((item) => ({ ...item }));

            clone.push(data);

            this.setState({ cloudFunctionLogs: clone });
        }
    }

    onCloudFunctionEnd (data) {
        let {
            cloudFunctionLogs
        } = this.state;

        let indexes = [];
        
        let requestIdArray = cloudFunctionLogs.map((item) => item.requestId);

        let firstIndex = requestIdArray.indexOf(data.requestId);
        let lastIndex = requestIdArray.lastIndexOf(data.requestId);
        
        if (
            firstIndex !== -1 &&
            firstIndex === lastIndex
        ) {
            indexes.push(firstIndex);
        } else {
            for (let index = firstIndex; index < lastIndex + 1; index++) {
                const item = cloudFunctionLogs[index];
                
                if (item.requestId === data.requestId) {
                    indexes.push(index);
                }
            }
        }
        

        if (indexes.length !== 0) {
            let clone = cloudFunctionLogs.map((item) => ({ ...item }));

            for (let index of indexes) {
                clone.splice(index, 1);
            }

            this.setState({ cloudFunctionLogs: clone });
        }

    }

    render () {
        let {
            cloudFunctionLogs
        } = this.state;

        return (
            <Panel>
                <Panel.Heading
                    style={{
                        backgroundColor: '#D1282F',
                        color: 'white'
                        }}
                >
                    <h4>SERVER PROCESS MONITORING</h4>
                </Panel.Heading>
                <Panel.Body>
                    <Tabs defaultActiveKey={1}>
                        <Tab eventKey={1} title="Cloud functions">
                            <h3>Total: {cloudFunctionLogs.length}</h3>
                            <ul>
                                {cloudFunctionLogs.length === 0 ? (
                                    <p>No running cloud functions</p>
                                ) : (
                                    cloudFunctionLogs.map((item, index) => {
                                        return (
                                            <li key={index}>
                                                <p>{item.requestId} - {item.functionName}</p>
                                            </li>
                                        );
                                    })
                                )}
                            </ul>
                        </Tab>  
                    </Tabs>
                </Panel.Body>
            </Panel>
        );
    }

    componentDidMount () {
        socket.on(
            "CLOUD_FUNCTION_START",
            (data) => {
                this.onCloudFunctionStart(data);
            }
        );

        socket.on(
            "CLOUD_FUNCTION_END",
            (data) => {
                this.onCloudFunctionEnd(data);
            }
        );
    }

    componentWillUnmount () {
        socket.off("CLOUD_FUNCTION_START");

        socket.off("CLOUD_FUNCTION_END");
    }
}


// WEBPACK FOOTER //
// ./components/ServerProcessMonitoring/index.js